export default __webpack_public_path__ + "1a504a4da9f40f9f81dbc77deb5a8316.png";